import api from '@/lib/api'

const state = () => ({
  byAccount: { labels: [], data: [] },
  byService: { labels: [], data: [] },
  detail: [],
})

const getters = {
  byAccount: state => state.byAccount,
  byService: state => state.byService,
  detail: state => state.detail,
}

const actions = { 
  async loadByAccount ({ commit }, { limit = null, days=null } = {}) {
    const method = '/dashboard/by_account'

    let params = new URLSearchParams()
    if (limit) params.append( 'limit', limit )
    if (days) params.append( 'days', days )

    const result = await api.get(method +  (params.toString() ? '?' + params : ''))
    if (result.ok) {
      const data = await result.json()
      commit('SET_BY_ACCOUNT', data)
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadByService ({ commit }, { limit=null, days=null } = {}) {
    const method = '/dashboard/by_service'

    let params = new URLSearchParams()
    if (limit) params.append( 'limit', limit )
    if (days) params.append( 'days', days )

    const result = await api.get(method +  (params.toString() ? '?' + params : ''))
    if (result.ok) {
      const data = await result.json()
      commit('SET_BY_SERVICE', data)
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadDetail ({ commit }, { days=null, account_ids=[], service_ids=[] } = {}) {
    let method = '/dashboard/detail'

    let params = new URLSearchParams()
    if (days) params.append('days', days)
    account_ids.forEach( id => params.append('account_ids[]', id) )
    service_ids.forEach( id => params.append('service_ids[]', id) )

    const result = await api.get(method +  (params.toString() ? '?' + params : ''))
    
    if (result.ok) {
      const data = await result.json()
      commit('SET_DETAIL', data)
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_BY_ACCOUNT: (state, data) => state.byAccount = data,
  SET_BY_SERVICE: (state, data) => state.byService = data,
  SET_DETAIL: (state, data) => state.detail = data,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}